export enum PageCode {
    // ----------PERFORMANCE----------

    COMPETENCY_QUESTION_DEFINITION = 'HRM_COM_C_DEF_0001',
    COMPETENCY_GROUP_SUBGROUP_REL = 'HRM_PRF_C_DEF_0002',
    EVALUATOR_GROUP_SUBGROUP_REL = 'HRM_PRF_C_DEF_0003',
    PERFORMANCE_PERIOD = 'HRM_PRF_C_DEF_0004',
    COMPETENCY_PERFORMANCE_PERIOD = 'HRM_PRF_C_DEF_0004_1',
    OBJECTIVE_PERFORMANCE_PERIOD = 'HRM_PRF_C_TPP_0001',
    OBJECTIVE_PERFORMANCE_PERIOD_CARDS = 'HRM_PRF_C_TPP_0002',
    COMPETENCY_EVALUATION_FORM_REPORT = 'HRM_COM_C_EFR_0001',
    COMPETENCY_EDF_PROCESS_REPORT = 'HRM_COM_C_EPR_0001',
    COMPETENCY_EVALUATION_FORM = 'HRM_COM_C_EFO_0001',
    COMPETENCY_BATCH_EVALUATION = 'HRM_COM_C_CBE_0001',
    HIERARCHY_GROUP_DETAIL = 'HRM_CFG_C_OBJ_0001',
    OBJECT_RELATIONSHIP = 'HRM_CFG_C_OBJ_0002',
    OBJECT_CONTENT = 'HRM_CFG_C_OBJ_0003',
    OBJECT_DEFINITION = 'HRM_CFG_C_OBJ_0004',
    OBJECT_DETAIL = 'HRM_CFG_C_OBJ_0005',
    OBJECT_CONNECTION = 'HRM_CFG_C_OBJ_0006',
    OBJECTIVE_PERIOD_REL = 'HRM_OBJ_C_DEF_0002',
    BULK_OBJECTIVE_ASSIGNMENT = 'HRM_OBJ_C_BLK_0002_L',
    PERSONNEL_OBJECTIVE = 'HRM_OBJ_C_DEF_0003',
    PERSONNEL_CRITERIA = 'HRM_OBJ_C_DEF_0004',
    PERSONNEL_TYPE_PERSONNEL_REL = 'HRM_PRF_C_DEF_0007',
    PERFORMANCE_HIERARCHY = 'HRM_OBJ_C_DEF_0007',
    PARTICIPANT_GROUP = 'HRM_OBJ_C_DEF_0006',
    PARTICIPANT = 'HRM_OBJ_C_DEF_0008',

    CODE_TEXT = 'HRM_CFG_C_DEF_0001',
    CODE_TEXT_PERSONNEL = 'HRM_PER_C_COD_0444',
    CODE_TEXT_PAYROLL = 'HRM_PAY_C_DEF_0012',
    CODE_TEXT_PERFORMANCE = 'HRM_PRF_C_DEF_0001',
    EMPLOYEE_SUBTYPE = 'HRM_CFG_C_DEF_0002',
    WORK_SUBAREA = 'HRM_CFG_C_DEF_0003',
    TYPE_EDU_SUBTYPE = 'HRM_CFG_C_DEF_0004',
    SUBTYPE_SCHOOL = 'HRM_CFG_C_DEF_0005',
    HRM_DETAIL = 'HRM_CFG_C_OPT_0001',
    HRM_DETAIL_TYPE = 'HRM_CFG_C_OPT_0002',
    IDENTIFICATION_SUBTYPE = 'HRM_CFG_C_DEF_0008',
    CODE_TEXT_MODULE_RELATION = 'HRM_CFG_C_DEF_0009',
    CODE_TEXT_RELATION = 'HRM_GEN_C_CTR_001',
    LEAVE_REQUEST = 'HRM_PER_C_ACT_0001',
    LEAVE_REQUEST_BULK = 'HRM_PER_C_LRB_0001',
    LEAVE_REQUEST_BULK_LIST = 'HRM_PER_C_LRB_0001_L',
    LEAVE_REQUEST_BULK_FORM = 'HRM_PER_C_LRB_0001_U',
    LEAVE_REQUEST_BULK_HISTORY = 'HRM_PER_C_LRB_0001_H',
    TIME_CONSTRAINT = 'HRM_CFG_C_DEF_0011',
    CONTRACT_FORM = 'HRM_CFG_C_DEF_0010',
    PER_EMPLOYEE_CARD = 'HRM_CFG_C_ECA_0001_U',
    AUTHORIZATION_PAGE = 'HRM_CFG_C_AUT_0001_U',
    MAIL_SUBGROUP = 'HRM_PER_C_MSB_0001_U',

    EXTERNAL_APPLICATION = 'HRM_PER_C_APP_0001',
    ADDRESS = 'HRM_PER_C_ADD_0001',
    AWARD = 'HRM_PER_C_AWR_0001',
    BANK = 'HRM_PER_C_BNK_0001',
    IDENTITY = 'HRM_PER_C_IDE_0001',
    SYNDICATE = 'HRM_PER_C_SYN_0001',
    SPECIAL_SITUATION = 'HRM_PER_C_SPE_0001',
    CERTIFICATE = 'HRM_PER_C_CRT_0001',
    DEGREE = 'HRM_PER_C_DEG_0001',
    EDUCATION = 'HRM_PER_C_EDU_0001',
    COURT = 'HRM_PER_C_COU_0001',
    PER_LEGAL_REGULATIONS = 'HRM_PER_C_LRG_0001',
    DECLARATION_GOODS = 'HRM_PER_C_DGS_0001',
    DECLARATION_GOODS_REAL_ESTATE = 'HRM_PER_C_DGS_0001',
    DECLARATION_GOODS_COOPERATIVE = 'HRM_PER_C_DGS_0002',
    DECLARATION_GOODS_VEHICLE_INFO = 'HRM_PER_C_DGS_0003',
    DECLARATION_GOODS_OTHER_CHATTEL = 'HRM_PER_C_DGS_0004',
    DECLARATION_GOODS_BANK_SECURITIES = 'HRM_PER_C_DGS_0005',
    DECLARATION_GOODS_GOLD_JEWELERY = 'HRM_PER_C_DGS_0006',
    DECLARATION_GOODS_DEBT_RECEIVABLE = 'HRM_PER_C_DGS_0007',
    DECLARATION_GOODS_RIGHTS_OTHER_WEALTH = 'HRM_PER_C_DGS_0008',
    DECLARATION_GOODS_EXPLANATIONS = 'HRM_PER_C_DGS_0009',
    CONTRACT = 'HRM_PER_C_CTR_0001',
    EXAM = 'HRM_PER_C_EXA_0001',
    SUBEXAM = 'HRM_PER_SHL_SUB_0001',
    FOREIGN_LANGUAGE = 'HRM_PER_C_FOR_0001',
    HISTORICAL_DATA = 'HRM_PER_C_HIS_0001',
    IDENTIFICATION = 'HRM_PER_C_IDN_0001',
    WEAPON = 'HRM_PER_C_WEA_0001',
    VEHICLE = 'HRM_PER_C_VEH_0001',
    TELEPHONE = 'HRM_PER_C_TEL_0001',
    TRIP = 'HRM_PER_C_TRIP_0001',
    PHYSICAL_STANDARD = 'HRM_PER_C_PHY_0001',
    EXPERIENCE = 'HRM_PER_C_EXP_0001',
    PERSONNEL_ORGANIZATION = 'HRM_PER_C_ORG_0001',
    PERSONNEL_MOVEMENT = 'HRM_PER_C_MOV_0001_U',
    HEALTH = 'HRM_PER_C_HEA_0001',
    MILITARY = 'HRM_PER_C_MIL_0001',
    BORROWING = 'HRM_PER_C_BRR_0001',
    EXTERNAL_DATA = 'HRM_PER_C_EXT_0001',
    PUNISHMENT = 'HRM_PER_C_PUN_0001',
    INVESTIGATION = 'HRM_PER_C_INV_0001',
    PERSONNEL = 'HRM_PER_C_PER_0001',
    ORG_LIST = 'HRM_ORG_C_LST_0001',
    SUSPENSION = 'HRM_PER_C_SUS_0001',
    PERSONNEL_MANAGER_PANEL = 'HRM_PER_C_PER_0003',
    FAMILY = 'HRM_PER_C_FAM_0001',
    WAGE_MANAGEMENT = 'HRM_PER_C_PAY_0001',
    COMMON_PAY = 'HRM_PER_C_PAY_0002',
    INDIVIDUAL_PAY = 'HRM_PER_C_PAY_0003',
    DEDUCTION = 'HRM_PER_C_PAY_0004',
    ADDITIONAL_PAYMENT = 'HRM_PER_C_PAY_0005',
    CRITERIA_CATALOG = 'HRM_PRF_C_CAT_0001',
    EVALUATION_PATH = 'HRM_PRF_E_PTH_0001',
    EVALUATION_AREA = 'HRM_PRF_E_ARE_0001',
    PER_ORG_GNRL_INFO = 'HRM_ORG_C_GEN_0001',
    PER_ORG_STATIC_INFO = 'HRM_ORG_C_STA_0001',
    PER_ORG_MOV_INFO = 'HRM_ORG_C_MOV_0001',
    PER_ORG_SUB_INFO = 'HRM_ORG_C_SUB_0001',
    PER_ORG_EMP_INFO = 'HRM_ORG_C_EMP_0001',
    PER_ORG_RESP_INFO = 'HRM_ORG_C_RES_0001',
    PER_ORG_ADDRESS_INFO = 'HRM_ORG_C_ADD_0001',
    PER_ORG_ATTACHMENT_INFO = 'HRM_ORG_C_ATT_0001',
    PER_ORG_CTG_INFO = 'HRM_ORG_C_GTG_0444',
    ORG_VER = 'HRM_ORG_C_VER_0001',
    EXPENSE_INFO = 'HRM_PER_C_EPI',
    FLAT_ALLOCATION = 'HRM_PER_C_FLAT',
    WORK_CERTIFICATE_DEMAND = 'HRM_PER_C_WDD_0001',
    MOVEMENT_REQUEST_PERIOD = 'HRM_PER_C_MR_001',
    MOVEMENT_REQUEST_RULE = 'HRM_PER_C_MR_002',
    MOVEMENT_REQUEST = 'HRM_PER_C_MR_003',
    MOVEMENT_REQUEST_ADMIN = 'HRM_PER_C_MR_004',

    CADRE_DEFINITION = 'HRM_ORG_C_CAD_0001',
    CADRE_DETAIL = 'HRM_ORG_C_CDI_0001',
    PER_ORG_CADRE_SWITCH_INFO = 'HRM_ORG_C_CDF_0001',
    CADRE_GENERAL_INFO = 'HRM_ORG_C_CAD_0002',
    CADRE_DEF_MOVEMENT = 'HRM_ORG_C_CAD_0003',
    CADRE_PERSONNEL_LIST = 'HRM_ORG_C_CAD_0004',
    CADRE_CHILD_CADRE_LIST = 'HRM_ORG_C_CAD_0005',
    CADRE_PERIOD = 'HRM_ORG_C_CDF_0002',
    CADRE_FEATURE = 'HRM_ORG_C_CDF_0003',
    PERIOD_FEATURE = 'HRM_ORG_C_CDF_0005',
    TITLE = 'HRM_ORG_C_TIT_0001',
    POSITION = 'HRM_ORG_C_POS_0001',
    PERIOD_SWITCH_ASSIGNMENT = 'HRM_ORG_C_CDF_0004',
    DISABILITY = 'HRM_PER_C_DIS_0001',
    DEGREE_EDUCATION_LEVEL = 'HRM_PER_C_DGR_0003',
    PERSONNEL_DEGREES = 'HRM_PER_C_DGR_0004',
    MONTHLY_INDICATOR = 'HRM_PER_C_DGR_0001',
    ADDITIONAL_INDICATOR = 'HRM_PER_C_DGR_0002',
    VEHICLE_MAKE_REL = 'HRM_PER_C_CTR_0004',
    ACCIDENT = 'HRM_PER_C_ACC_001',
    SECONDMENT = 'HRM_PER_C_SEC_0001',
    SECONDMENT_APPROVEMENT = 'HRM_PER_C_SEC_0001_MX_x',
    TERMINATION = 'HRM_PER_C_TER_0001',

    ORGANIZATION_TREE = 'HRM_ORG_C_TRE_0444',
    ORGANIZATION_SCHEME = 'HRM_ORG_C_SCH_0444',
    ORGANIZATION_HEADER = 'HRM_ORG_C_HDR_OOO1',
    ORGANIZATION_TEMPLATE = 'HRM_ORG_C_GEN_0001',

    PAYROLL_NAME = 'HRM_PAY_C_DEF_0008',
    PAYROLL_SWITCH = 'HRM_PAY_C_DEF_0005',
    PAYROLL_PERIOD_DATE = 'HRM_PAY_C_DEF_0006',
    PAYROLL_SWITCH_STATE = 'HRM_PAY_C_DEF_0007',
    PAYROLL_SWITCH_RELATION = 'HRM_PAY_C_PSR_0001',
    TRAVEL_WAGE_TYPE_RELATION = 'HRM_PAY_C_DEF_0019',
    PAYROLL_SWITCH_OFFSET_DATE = 'HRM_PAY_C_DEF_0021',
    PAY_WAGE_TYPE = 'HRM_PAY_C_WGT_0001',
    GROUP_EMPLOYEE_SUBTYPE = 'HRM_PAY_C_DEF_0002',
    GROUP_WORK_SUBAREA = 'HRM_PAY_C_DEF_0001',
    SCRIPT = 'HRM_PAY_C_DEF_0013',
    RESULT = 'HRM_PAY_C_TRA_0002',
    PAYROLL_RUN = 'HRM_PAY_C_TRA_0002',
    PAYROLL_CALCULATION_STATUS = 'HRM_PAY_C_TRA_0001',
    PERSONNEL_PAYROLL_DAILY = 'HRM_PAY_C_REP_0003',
    PAY_CONSTANT_NUMBER = 'HRM_PAY_C_DEF_0010',
    PAY_CONSTANT_AMOUNT = 'HRM_PAY_C_DEF_0009',
    PAY_WT_MANNER_VALUE = 'HRM_PAY_C_DEF_0006',
    PAY_WT_CUMULATIVE = 'HRM_PAY_C_DEF_0004',
    PAY_CONSTANT_PUBLIC = 'HRM_PAY_C_PDF_0014',
    SST_PERCENTAGE = 'HRM_PAY_C_LEG_0002',
    INS_TYPE_WAGE_TYPE_REL = 'HRM_PAY_C_DEF_0017_L',
    INS_TYPE_WAGE_TYPE_REL_U = 'HRM_PAY_C_DEF_0017_U',

    PAY_WT_CHAR_WSA = 'HRM_PAY_C_DEF_0016',
    PAY_WT_CHAR_EST = 'HRM_PAY_C_DEF_0017',
    PAY_WT_CHARACTERISTIC = 'HRM_PAY_C_DEF_0018',
    PAY_WT_VAL_MANNER_DETAIL = 'HRM_PAY_C_DEF_0020',
    PAY_STAMP_TAX_RATE = 'HRM_PAY_C_LEG_0003',
    PAY_SST_INFO = 'HRM_PAY_C_LEG_0001',
    PAY_TAX_MANAGEMENT_TR = 'PAY_TAX_MANAGEMENT_TR',
    PAY_GROUP_WORK_INFO_TR = 'PAY_GROUP_WORK_INFO_TR',
    PAY_SALARY_SLIP_REPORT = 'HRM_PAY_C_BZ_0015',

    PER_MOVEMENT_KIND = 'HRM_PER_C_KIND_0001',
    PER_MOVEMENT_INFO = 'HRM_PER_C_INFO_0001',
    PER_MOVEMENT_RETURN_STATUS = 'HRM_PER_C_CTR_0003',
    PER_MOVEMENT_SERVICE_STATUS = 'HRM_PER_C_CTR_0002',
    PER_MOVEMENT_ST_MANDATORY_FIELDS = 'HRM_PER_C_STMF_0001',
    PER_ATTACHMENT = 'HRM_PER_ATT_0001',

    PAY_INCOME_TAX_BRACKET = 'HRM_PAY_C_LEG_0005',
    PAY_MIN_LIV_ALLOWANCE_AMOUNT = 'HRM_PAY_MLAM_DEF_0001',
    PAY_SI_DEDUCTION_LAW_RATE = 'HRM_PAY_C_LEG_0006',
    PAY_TRAVEL_EXPENSE_DEDUCTION_AMOUNT = 'HRM_PAY_C_LEG_0008',
    EVALUATION_RULE = 'HRM_PRF_E_RUL_0001',

    HRM_PAY_INFO = 'HRM_PER_C_PAY_0007',
    HRM_PAY_INFO_DEDUCTION = 'HRM_PER_C_PAY_002',
    HRM_PAY_INFO_RD = 'HRM_PER_C_PAY_003',
    HRM_PAY_INFO_TAX = 'HRM_PER_C_PAY_004',
    HRM_PAY_INFO_SGK = 'HRM_PER_C_PAY_005',

    HRM_PAY_C_ALI_0001 = 'HRM_PER_C_PAY_0008',
    HRM_PAY_C_ALI_0002 = 'HRM_PER_C_PAY_0008',

    HRM_PER_C_DGR_0005 = 'HRM_PER_C_DGR_0005',

    HRM_PER_C_DGR_0005_U = 'HRM_PER_C_DGR_0005_U',
    HRM_PER_C_DGR_0005_D = 'HRM_PER_C_DGR_0005_D',
    HRM_PER_C_DGR_0005_I = 'HRM_PER_C_DGR_0005_I',

    HRM_PER_C_PAY_0010 = 'HRM_PER_C_PAY_0010',
    HRM_PER_C_PAY_0010_L = 'HRM_PER_C_PAY_0010_L',
    HRM_PER_C_PAY_0010_U = 'HRM_PER_C_PAY_0010_U',
    HRM_PER_C_PAY_0010_D = 'HRM_PER_C_PAY_0010_D',
    HRM_PER_C_DED_002 = 'HRM_PER_C_DED_002',

    HRM_PER_C_PAY_0011 = 'HRM_PER_C_PAY_0011',
    HRM_PER_C_PAY_0013 = 'HRM_PER_C_PAY_0013',

    HRM_PER_C_CRT_0001 = 'HRM_PER_C_CRT_0001',
    HRM_PER_C_MAH_0001 = 'HRM_PER_C_MAH_0001 ',
    HRM_PAY_C_EXE_0001 = 'HRM_PER_C_PAY_0009',
    HRM_PAY_C_EXE_0002 = 'HRM_PER_C_PAY_0009',
    HRM_PAY_C_EXE_0003 = 'HRM_PAY_C_EXE_0003',

    PER_HTP_SRV_STS_001 = 'PER_HTP_SRV_STS_0001',
    PER_HTP_SRV_RSN_001 = 'PER_HTP_SRV_RSN_0001',
    PER_HTP_FRM_OF_RTRN_001 = 'PER_HTP_FRM_OF_RTRN_0001',
    HRM_HTP_C_DEF_0002 = 'HRM_HTP_C_DEF_0002',

    HRM_PER_HATA_KODU_0001_L = 'HRM_PER_HATA_KODU_0001_L',
    HRM_PER_HATA_KODU_0001_U = 'HRM_PER_HATA_KODU_0001_U',

    HRM_ORG_C_EMP_0001_L = 'HRM_ORG_C_EMP_0001_L',
    HRM_ORG_C_EMP_0001_U = 'HRM_ORG_C_EMP_0001_U',
    HRM_ORG_C_FUL_0001_L = 'HRM_ORG_C_FUL_0001_L',
    HRM_ORG_C_FUL_0001_U = 'HRM_ORG_C_FUL_0001_U',

    HRM_REC_C_PRM_0008 = 'HRM_REC_C_PRM_0008',
    HRM_REC_C_PRM_0008_L = 'HRM_REC_C_PRM_0008_L',
    HRM_REC_C_PRM_0008_U = 'HRM_REC_C_PRM_0008_U',

    HRM_HTP_C_MTC_0002 = 'HRM_HTP_C_MTC_0002',
    PER_HTP_SRV_RSN_DM_001 = 'HRM_HTP_C_DEF_0004',
    PER_HTP_FRM_OF_RTRN_DM_001 = 'PER_HTP_FRM_OF_RTRN_DM_0001',

    HRM_PAY_C_RID_0001 = 'HRM_PAY_C_RID_0001',
    HRM_HTP_C_HDC_0001_L = 'HRM_HTP_C_HDC_0001_L',

    HRM_HTP_C_HKA_0001 = 'HRM_HTP_C_HKA_0001',
    HRM_HTP_C_HKA_0001_L = 'HRM_HTP_C_HKA_0001_L',

    HRM_PAY_C_DEF_0015 = 'HRM_PAY_C_DEF_0015',

    HRM_PER_C_ADP_0001_L = 'HRM_PER_C_ADP_0001_L',
    HRM_PER_C_ADP_0001_U = 'HRM_PER_C_ADP_0001_U',
    HRM_PER_C_ADP_0001_APPROVE = 'HRM_PER_C_ADP_0001_A',
    HRM_PAY_C_MAN_001 = 'HRM_PAY_C_MAN_0013',
    HRM_PAY_C_MOV_001 = 'HRM_PAY_C_MOV_001',

    HRM_BPMN_C_ASG_0001_L = 'HRM_BPMN_C_ASG_0001_L',
    HRM_BPMN_C_ASG_0001 = 'HRM_BPMN_C_ASG_0001',

    HISTORICAL_DATA_BATCH_IMPORT = 'HRM_PER_C_MAS_0001',
    ORGANIZATION_TYPE = 'HRM_PER_C_ORG_0444',
    HRM_PER_POS_COURSE_INFO_001 = 'HRM_PER_POS_COURSE_INFO_001',

    HRM_PRF_C_UNT_0001 = 'HRM_PRF_C_UNT_0001',

    PAY_ADDITIONAL_PAY_RATE = 'HRM_PAY_C_PDF_0001',
    ADMIN_DUTY_ALLOWANCE_RATE = 'HRM_PAY_C_PDF_0003',
    PAY_POS_DUTY_PAY_RATE = 'HRM_PAY_C_PDF_0008',
    PAY_FOREIGN_LANG_COM = 'HRM_PAY_C_PDF_0010',
    PAY_FRINGE_PAY_POINT = 'HRM_PAY_C_PDF_0007',
    PAY_DEV_PAY_RATE = 'HRM_PAY_C_PDF_0009',
    PAY_RETIREMENT_DEDUCTION_RATE = 'HRM_PAY_C_PDF_0002',
    PAY_ADMIN_DUTY_ALLOWANCE_RATE = 'HRM_PAY_C_PDF_0003',
    PAY_SPECIAL_SERVICE_COMP_RATE = 'HRM_PAY_C_PDF_0004',
    PAY_UNIVERSITY_ALLOWANCE_RATE = 'HRM_PAY_C_PDF_0005',
    PAY_HIGHER_EDU_COMPENSATION_RATE = 'HRM_PAY_C_PDF_0006',
    PAY_REGION_REGION_TYPE_RELATION = 'HRM_PAY_C_PDF_0011',
    PAY_REGION_SUBPROVINCE_MATCH = 'HRM_PAY_C_PDF_0012',
    PAY_COMPENSATIONS_ALLOWANCES = 'HRM_PAY_C_PDF_0013',

    TASK_DEFINITION = 'MIL_ORG_L_CON_0025',
    TASK_GROUP_DEFINITION = 'MIL_ORG_L_CON_0026',
    TASK_GROUP_DEFINITION_RELATION = 'HRM_TASK_GRP_DEF_REL_0001',
    TASK_RELATION = 'HRM_ORG_C_GTG_0444',
    TASK_GROUP_RELATION = 'HRM_TASK_GRP_REL_0001',
    HRM_PER_SYNDICATE_DEF_REL_0001 = 'HRM_PER_MLM_0444',

    // ----------RECRUITMENT----------
    RECRUITMENT_ANNOUNCEMENT_POSITION = 'HRM_ANN_C_POS_0001',
    RECRUITMENT_REQUIREMENT_POSITION = 'HRM_REC_C_EVA_0001',
    RECRUITMENT_PROCESS = 'HRM_REC_C_PRO_0001',
    RECRUITMENT_PER_EVALUATION_BOARD = 'HRM_REC_C_PBR_0001',
    RECRUITMENT_PAY_MANAGEMENT = 'HRM_REQ_C_COF_0002',
    RECRUITMENT_REL_PAR = 'HRM_REC_C_RATIO_0001',
    RECRUITMENT_INDIVIDUAL_TRANSACTION = 'HRM_CON_C_STR_0001',
    RECRUITMENT_ANNOUNCEMENT_APPLICATIONS = 'RECRUITMENT_ANNOUNCEMENT_APPLICATIONS',
    RECRUITMENT_ANNOUNCEMENT_DASHBOARD = 'HRM_REC_C_ANN_0001',
    RECRUITMENT_APPLICATION_SEARCH = 'HRM_REC_C_REV_0001',
    RECRUITMENT_REQ_BUDGET = 'HRM_APP_C_REQ_0001',
    RECRUITMENT_BOARD = 'HRM_APP_C_BRD_0001',
    RECRUITMENT_TAB_HR_BOARD = 'HRM_REC_C_BRD_0001',
    RECRUITMENT_GUIDE = 'HRM_REC_C_GUI_0001',
    RECRUITMENT_POSITION_SOFT_SKILL = 'HRM_APP_C_PSM_0001',
    RECRUITMENT_INTERN_DEPARTMENT = 'HRM_REC_C_IND_0001',
    RECRUITMENT_STARTING = 'HRM_REC_C_STR_0001',
    RECRUITMENT_RELATION_PARAMETER = 'HRM_ANN_C_POS_0001',
    RECRUITMENT_COLLECTIVE_POLICY_UPDATE = 'HRM_REC_C_PRM_0001',
    RECRUITMENT_CHANGING = 'HRM_REC_C_CHA_0001',

    RECRUITMENT_PEER_LEVEL_AND_WORK_FAMILY = 'HRM_CON_C_FAM_0001',
    HRM_REC_C_APP_0001_L = 'HRM_REC_C_APP_0001_L',
    HRM_REC_EXT_PAY_MANAGEMENT = 'HRM_REC_EXT_PAY_001',

    RECRUITMENT_MY_REQUIREMENT = 'HRM_REC_C_REQ_0001',
    RECRUITMENT_REQUIREMENT_APPROVAL = 'HRM_CON_C_REQ_0001',
    RECRUITMENT_MY_INTERN_REQUIREMENT = 'HRM_REC_C_INR_0001',
    RECRUITMENT_INTERN_REQUIREMENT = 'HRM_REC_C_IRA_0001',
    RECRUITMENT_INTERN_APPLY = 'HRM_IAP_C_REV_0005_L',

    RECRUITMENT_IN_APPLICATION = 'HRM_REC_C_INA_0001',
    PERSONNEL_PICKER = 'HRM_PERSONNEL_PICKER',

    PUNISHMENT_SUBTYPE = 'HRM_CFG_C_DEF_0009',
    HRM_PER_C_TPR_0444 = 'HRM_PER_C_TPR_0444',
    HRM_PER_C_SMR_0444 = 'HRM_PER_C_SMR_0444',
    HRM_HTP_C_INT_0001 = 'HRM_HTP_C_INT_0001',
    HRM_HTP_C_OPT_0004 = 'HRM_HTP_C_OPT_0004',
    HRM_HTP_C_OPT_0003 = 'HRM_HTP_C_OPT_0003',
    HRM_HTP_C_OPT_0001 = 'HRM_HTP_C_OPT_0001',
    REC_FORM_CREATE = 'HRM_APP_C_FRM_0001',
    REC_LOC_PARAMETER = 'HRM_REC_C_PRM_0004',
    REC_EDU_PARAMETER = 'HRM_REC_C_PRM_0003',
    REC_BUS_PARAMETER = 'HRM_REC_C_PRM_0005',
    REC_BUS_FAM_PARAMETER = 'HRM_REC_C_PRM_0009',
    HRM_REC_C_PRM_0005 = 'HRM_REC_C_PRM_0005',
    EXPERIENCE_MERGE = 'HRM_PER_C_EXM_0001',
    EXCEPTION_RELATION = 'HRM_PER_C_HII_0001',
    CREDIBLE_EXPERIENCE = 'HRM_PER_C_IHS_0001_L',
    COMPENSATION = 'HRM_PER_C_CMP_0001',
    EXAM_INTEGRATION = 'HRM_PER_C_ENT_0001',
    HTP_COURSE_EDUCATION_MATCH = 'HRM_HTP_C_MTC_0003',
    UNI_FACULTY_INTEGRATION = 'HRM_PER_C_ENT_0002',
    DEGREE_ADVANCEMENT = 'HRM_PER_C_DKT_0001',
    COMMISSION = 'HRM_PER_C_COM_0001',
    HRM_PAY_C_LEG_0007 = 'HRM_PAY_C_LEG_0007',
    REC_EXE_DASHBOARD = 'HRM_REC_C_MPN_0444',
    HRM_ORG_C_EMPT_0001_L = 'HRM_ORG_C_EMPT_0001_L',
    HRM_ORG_C_EMPT_0001_U = 'HRM_ORG_C_EMPT_0001_U',
    HRM_ORG_C_EMPT_0003_L = 'HRM_ORG_C_EMPT_0003_L',
    HRM_ORG_C_EMPT_0003_U = 'HRM_ORG_C_EMPT_0003_U',
    HRM_ORG_C_EMPT_0004_L = 'HRM_ORG_C_EMPT_0004_L',
    HRM_ORG_C_EMPT_0004_U = 'HRM_ORG_C_EMPT_0004_U',
    HRM_ORG_C_EMPT_0002_L = 'HRM_ORG_C_EMPT_0002_L',
    HRM_ORG_C_FUL_0002_L = 'HRM_ORG_C_FUL_0002_L',
    HRM_ORG_C_FUL_0002_U = 'HRM_ORG_C_FUL_0002_U',
    HRM_PER_C_PER_0001_U = 'HRM_PER_C_PER_0001_U',
    HRM_PER_C_PER_0002_U = 'HRM_PER_C_PER_0002_U',
    HRM_ORG_C_CON_0001 = 'HRM_ORG_C_CON_0001',
    HRM_ORG_C_ORG_0001 = 'HRM_ORG_C_ORG_0001',
    HRM_ORG_C_PER_0001 = 'HRM_ORG_C_PER_0001',
    HRM_ORG_C_SPE_0001 = 'HRM_ORG_C_SPE_0001',
    HRM_ORG_C_CAL_0001 = 'HRM_ORG_C_CAL_0001',
    HRM_PER_C_CMEM_0001 = 'HRM_PER_C_CMEM_0001',
    HRM_ORG_C_POS_0003 = 'HRM_ORG_C_POS_0003',
    HRM_ORG_C_POS_0006 = 'HRM_ORG_C_POS_0006',
    HRM_ORG_C_POS_0004 = 'HRM_ORG_C_POS_0004',
    HRM_POS_C_CON_0001 = 'HRM_POS_C_CON_0001',
    HRM_ORG_C_POS_0007 = 'HRM_ORG_C_POS_0007',
    HRM_POS_C_TASK_0001 = 'HRM_POS_C_TASK_0001',
    HRM_ORG_C_TIT_0003 = 'HRM_ORG_C_TIT_0003',
    HRM_ORG_C_TIT_0002 = 'HRM_ORG_C_TIT_0002',
    HRM_ORG_C_TIT_0004 = 'HRM_ORG_C_TIT_0004',
    HRM_ORG_C_TIT_0006 = 'HRM_ORG_C_TIT_0006',
    HRM_GEN_C_ENM_0001 = 'HRM_GEN_C_ENM_0001',
    HRM_PER_H_PTR_0001_LIST = 'HRM_PER_H_PTR_0001_LIST',
    HRM_PER_H_PTR_0001_PAGE = 'HRM_PER_H_PTR_0001_PAGE',
    HRM_PAY_CORRECTION_PAYMENT = 'HRM_PAY_C_TRA_0005',
    CREDIBLE_EXPERIENCE_TIME_PAGE = 'HRM_ORG_C_CDF_0002_MX',
    CREDIBLE_EXPERIENCE_TIME_LIST = 'HRM_ORG_C_CDF_0002_MX_L',
    HRM_PER_C_OAR_0444 = 'HRM_PER_C_OAR_0444',
    HRM_PER_C_ATA_0001 = 'HRM_PER_C_ATA_0001',
    HRM_PER_PERSONNEL_IMPORT = 'HRM_PER_C_IMP_001',
    HRM_PER_PERSONNEL_IMPORT_APPROVAL = 'HRM_PER_C_IMP_001_A',
    PER_INSURANCE_INFO = 'HRM_PER_C_PINS_0001_L',
    PER_RECEIPT_INFO = 'HRM_PER_C_PINS_0002_L',
    HRM_PER_C_RPT_0001_L = 'HRM_PER_C_RPT_0001_L',
    HRM_PER_C_RPT_0001 = 'HRM_PER_C_RPT_0001',
    HRM_PER_C_RPT_0002_L = 'HRM_PER_C_RPT_0002_L',
    HRM_PER_C_RPT_0002 = 'HRM_PER_C_RPT_0002',
    HRM_PER_MASS_TERMINATION = 'HRM_PER_C_IMP_002',
    HRM_PER_MASS_TERMINATION_APPROVAL = 'HRM_PER_C_IMP_002_A',
    HRM_KPBS_C_PER_0001 = 'HRM_KPBS_C_PER_0001',
    HRM_KPBS_C_PER_0002 = ' HRM_KPBS_C_PER_0002',
    HRM_GEN_C_AUTH_0001 = 'HRM_GEN_C_AUTH_0001',
    HRM_TM_C_OVT_REP_0001 = 'HRM_TM_C_OVT_REP_0001',
    HRM_DEF_C_ANN_0001 = 'HRM_DEF_C_ANN_0001',
    HRM_REC_C_PRM_0006 = 'HRM_REC_C_PRM_0006',
    HRM_PAY_C_REP_005 = 'HRM_PAY_C_REP_005',
    HRM_PAY_C_ICM_REP_0001 = 'HRM_PAY_C_ICM_REP_0001',
    SUMMARY_REPORT = 'HRM_SUM_R_UY_0001',
    EXPENSE_TYPE_WAGE_TYPE_RELATION = 'HRM_PAY_C_DEF_0016',
    HRM_PAY_C_LEG_0004 = 'HRM_PAY_C_LEG_0004',
    PEOPLE_COURSE_PAGE = 'HRM_CRS_C_RPT_0040',
    HRM_HSM_C_ALL_0050 = 'HRM_HSM_C_ALL_0050',
    HRM_PER_C_PDD_0001 = 'HRM_PER_C_PDD_0001',

    HRM_PER_C_AT_0001_L = 'HRM_PER_C_AT_0001_L',
    HRM_PER_C_AT_0001_U = 'HRM_PER_C_AT_0001_U',
    HRM_PER_C_AT_0001_APPROVE = 'HRM_PER_C_AT_0001_A',

    TM_SHIFT_PLANING = 'HRM_TM_C_SHP_0001',

    HRM_CAR_C_REQ = 'HRM_CAR_C_REQ_0001',
    HRM_CAREER_PATH = 'HRM_CAR_C_PTH_0001',
    HRM_CAREER_PATH_TREE = 'HRM_CAR_C_PTH_T_0001',
    HRM_CAREER_SKILL = 'HRM_CAR_C_SKL_0001',
    HRM_CAREER_QUALITY = 'HRM_CAR_C_QLT_0001',
    HRM_CAREER_CRITERIA = 'HRM_CAR_C_CRT_0001',
    HRM_CAREER_CRITERIA_VALUE = 'HRM_CAR_C_CRV_0001',
    HRM_PER_CAREER_PATH = 'HRM_PER_C_PCP_0001',
    HRM_PER_CAREER_PATH_ADMIN = 'HRM_PER_C_CPM_0001',
    HRM_CAREER_REQ = 'HRM_CAR_C_REQ_0001',
    HRM_CAREER_REQ_ORG = 'HRM_CAR_C_REQ_O_0001',
    HRM_CAREER_REQ_TITLE = 'HRM_CAR_C_REQ_T_0001',
    HRM_CAREER_REQ_POS = 'HRM_CAR_C_REQ_P_0001',
    HRM_PER_CAREER_INFO = 'HRM_CAR_C_P_INF_0001',
    HRM_PER_CAREER_QUALITY = 'HRM_CAR_C_PER_0002',
    HRM_CAR_C_PER_0002 = 'HRM_CAR_C_PER_0002',
    HRM_PER_CAREER_SKILL = 'HRM_CAR_C_P_SKL_0001',
    HRM_CAREER_NINE_BOX_DEF = 'HRM_CAR_C_NBD_0001',

    HRM_GEN_ASSETS_PROCESS='HRM_GEN_C_FAS_0001',
    HRM_GEN_ASSETS_HISTORY='HRM_GEN_C_FAS_0002',
    HRM_PAY_TRAVEL_PAYROLL_TRANSFER='HRM_PAY_TRAVEL_PAYROLL_TRANSFER'
}
